import { useState, useEffect } from "react";

const entries = [
  { id: 1, name: "Sarah M.", method: "Instagram Follow", time: "Just now", avatar: "SM" },
  { id: 2, name: "Jake T.", method: "Email Signup", time: "2s ago", avatar: "JT" },
  { id: 3, name: "Priya K.", method: "Referral Bonus", time: "5s ago", avatar: "PK" },
  { id: 4, name: "Carlos R.", method: "Visit Website", time: "12s ago", avatar: "CR" },
  { id: 5, name: "Emma L.", method: "Instagram Follow", time: "18s ago", avatar: "EL" },
  { id: 6, name: "Noah W.", method: "Email Signup", time: "24s ago", avatar: "NW" },
];

const avatarColors = ["#0d9488", "#f97316", "#6366f1", "#ec4899", "#14b8a6", "#f59e0b"];

export default function HeroMockup() {
  const [visibleEntries, setVisibleEntries] = useState([entries[2], entries[3], entries[4]]);
  const [newEntry, setNewEntry] = useState(null);
  const [counter, setCounter] = useState(247);
  const [entryIndex, setEntryIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const next = entries[entryIndex % entries.length];
      setNewEntry(next);
      setCounter(c => c + 1);
      setVisibleEntries(prev => [next, ...prev.slice(0, 2)]);
      setEntryIndex(i => i + 1);
      setTimeout(() => setNewEntry(null), 800);
    }, 2200);
    return () => clearInterval(interval);
  }, [entryIndex]);

  return (
    <div style={{
      width: 520,
      height: 380,
      background: "#ffffff",
      borderRadius: 16,
      boxShadow: "0 32px 80px rgba(0,0,0,0.12), 0 8px 24px rgba(0,0,0,0.06)",
      overflow: "hidden",
      fontFamily: "'Inter', -apple-system, sans-serif",
      position: "relative",
      border: "1px solid #f1f5f9",
    }}>
      {/* Window chrome */}
      <div style={{
        background: "#f8fafc",
        borderBottom: "1px solid #e2e8f0",
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}>
        <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#fc5c65" }} />
        <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#fd9644" }} />
        <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#26de81" }} />
        <div style={{
          flex: 1,
          marginLeft: 8,
          background: "#e2e8f0",
          borderRadius: 6,
          height: 22,
          display: "flex",
          alignItems: "center",
          paddingLeft: 10,
          fontSize: 11,
          color: "#94a3b8",
        }}>
          rafflekit.app
        </div>
      </div>

      {/* App layout */}
      <div style={{ display: "flex", height: "calc(100% - 46px)" }}>
        {/* Sidebar */}
        <div style={{
          width: 48,
          background: "#0f172a",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 16,
          gap: 12,
        }}>
          {["▦", "◈", "◉", "◎"].map((icon, i) => (
            <div key={i} style={{
              width: 32, height: 32, borderRadius: 8,
              background: i === 0 ? "#0d9488" : "transparent",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, color: i === 0 ? "#fff" : "#475569",
              cursor: "pointer",
            }}>{icon}</div>
          ))}
        </div>

        {/* Main content */}
        <div style={{ flex: 1, padding: "16px", overflow: "hidden", background: "#f8fafc" }}>
          {/* Header row */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Summer Giveaway</div>
              <div style={{ fontSize: 11, color: "#64748b", marginTop: 1 }}>
                <span style={{ color: "#22c55e", marginRight: 4 }}>●</span>
                Active · Ends Aug 31
              </div>
            </div>
            <div style={{
              background: "#f97316",
              color: "#fff",
              fontSize: 10,
              fontWeight: 600,
              padding: "5px 10px",
              borderRadius: 6,
            }}>Pick Winner</div>
          </div>

          {/* Stats row */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 14 }}>
            {[
              { label: "Participants", value: counter.toLocaleString(), color: "#0d9488" },
              { label: "Total Entries", value: (counter * 3.2).toFixed(0) * 1, color: "#f97316" },
              { label: "Referrals", value: "48", color: "#6366f1" },
            ].map((stat, i) => (
              <div key={i} style={{
                background: "#ffffff",
                borderRadius: 8,
                padding: "8px 10px",
                border: "1px solid #e2e8f0",
              }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: stat.color }}>{stat.value}</div>
                <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 1 }}>{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Live entries feed */}
          <div style={{
            background: "#ffffff",
            borderRadius: 10,
            border: "1px solid #e2e8f0",
            overflow: "hidden",
          }}>
            <div style={{
              padding: "8px 12px",
              borderBottom: "1px solid #f1f5f9",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: "#475569" }}>Live Entries</span>
              <span style={{
                fontSize: 10,
                background: "#f0fdf4",
                color: "#22c55e",
                padding: "2px 7px",
                borderRadius: 20,
                fontWeight: 600,
              }}>● LIVE</span>
            </div>

            {visibleEntries.map((entry, i) => (
              <div key={`${entry.id}-${i}`} style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "8px 12px",
                borderBottom: i < 2 ? "1px solid #f8fafc" : "none",
                background: i === 0 && newEntry ? "#fffbf5" : "#fff",
                transition: "background 0.4s ease",
                animation: i === 0 && newEntry ? "slideIn 0.35s ease" : "none",
              }}>
                <div style={{
                  width: 28, height: 28, borderRadius: "50%",
                  background: avatarColors[entry.id % avatarColors.length],
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 10, fontWeight: 700, color: "#fff",
                  flexShrink: 0,
                }}>
                  {entry.avatar}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#1e293b" }}>{entry.name}</div>
                  <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 1 }}>{entry.method}</div>
                </div>
                <div style={{ fontSize: 10, color: "#cbd5e1", flexShrink: 0 }}>{entry.time}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Floating notification */}
      {newEntry && (
        <div style={{
          position: "absolute",
          top: 60,
          right: 16,
          background: "#fff",
          borderRadius: 10,
          padding: "10px 14px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          display: "flex",
          alignItems: "center",
          gap: 8,
          border: "1px solid #e2e8f0",
          animation: "popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
          zIndex: 10,
        }}>
          <div style={{
            width: 28, height: 28, borderRadius: "50%",
            background: "#dcfce7",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 14,
          }}>✓</div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#0f172a" }}>New Entry!</div>
            <div style={{ fontSize: 10, color: "#64748b" }}>via {newEntry.method}</div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes popIn {
          from { opacity: 0; transform: translateY(-8px) scale(0.92); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(-6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
